import { useEffect, useState } from "react";
import { ChatText } from "@phosphor-icons/react";
import client from "../lib/api";

const STATES = {
  approved: { label: "Texts LIVE", cls: "border-emerald-500/40 bg-emerald-500/10 text-emerald-300" },
  pending: { label: "Texts pending KYC", cls: "border-amber-500/40 bg-amber-500/10 text-amber-300" },
  draft: { label: "KYC not submitted", cls: "border-white/10 bg-white/[0.03] text-neutral-400" },
  rejected: { label: "KYC rejected", cls: "border-red-500/40 bg-red-500/10 text-red-300" },
  no_profile: { label: "No Trust Hub profile", cls: "border-white/10 bg-white/[0.03] text-neutral-500" },
  not_configured: { label: "SMS not configured", cls: "border-white/10 bg-white/[0.03] text-neutral-500" },
  error: { label: "SMS status unknown", cls: "border-white/10 bg-white/[0.03] text-neutral-500" },
};

export const TwilioStatusBadge = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    client.get("/admin/twilio-status").then((r) => setState(r.data.state)).catch(() => {});
  }, []);

  if (!state) return null;
  const cfg = STATES[state] || STATES.error;
  return (
    <span
      data-testid="twilio-status-badge"
      title="Twilio Trust Hub approval state — SMS alerts unlock when approved"
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-[11px] font-semibold ${cfg.cls}`}
    >
      <ChatText size={13} weight="bold" /> {cfg.label}
    </span>
  );
};
